// src/routes/Routers.jsx

import { Navigate, Route, Routes } from "react-router-dom";
import Home from "../pages/home/Home";
import About from "../pages/about/About";
import Project from "../pages/project/Project";
import Careers from "../pages/career/Careers";
import Blog from "../pages/blog/Blog";
import Contact from "../pages/contact/Contact";
import GeneralContracting from "../pages/contracting/GeneralContracting";
import EquipmentRental from "../pages/equipmentrental/EquipmentRental";
import ManpowerSupply from "../pages/manpowersupply/ManpowerSupply";
import Transportation from "../pages/transportation/Transportation";
import Footer from "../components/footer/Footer";
import TopHeader from "../components/topheader/TopHeader";
import Header from "../components/header/Header";
import Transport from "../pages/transport/Transport";
import BlogsTeam from "../pages/blog/BlogsTeam";
import JobDetails from "../pages/jobdetails/JobDetails";
import JobInfo from "../pages/jobinfo/JobInfo";
import ProjectDetails from "../pages/project/ProjectDetails";
import Quote from "../components/home/Quote";
import ResidentialProject from "../pages/residential/ResidentialProject";
import Commercial from "../pages/commercial/Commercial";
import Services from "../pages/services/Services";
import ViewProject from "../components/viewprojects/ViewProject";
import Infrastructure from "../pages/Infrastructure/Infrastructure";
import RenovationFinishing from "../pages/renovation-finishing/RenovationFinishing";
import ProjectSupervision from "../pages/project-supervision/ProjectSupervision";
import HeavyEquipment from "../pages/equipmentrental/HeavyEquipment";
import Excavators from "../pages/equipmentrental/Excavators";
import Bulldozers from "../pages/equipmentrental/Bulldozer";
import LightEquipment from "../pages/equipmentrental/light";
import Cranes from "../pages/cranes/Cranes";
import Loader from "../pages/loader/Loader";
import RentalTerms from "../pages/rentalterms/RentalTerms";
import Operator from "../pages/operator/Operator";
import WithoutOperator from "../pages/withoutoperator/WithoutOperator";
import Packages from "../pages/packages/Packages";
// import Electricians from "../pages/electricians/Electricians";
import Electricians from '../pages/electricians/Electricians';

import Plumbers from "../pages/plumbers/Plumbers";
import Welders from "../pages/welders/Welders";
import Technicians from "../pages/hvactechnicians/Technicians";
import MechanicalTechnicians from "../pages/mechanicaltechnicians/MechanicalTechnicians";
import CivilTechnicians from "../pages/civiltechnicians/CivilTechnicians";
import ShortTerm from "../pages/shortterm/ShortTerm";
import LongTerm from "../pages/longterm/LongTerm";
import MaterialTransport from "../pages/materialtransport/MaterialTransport";
import EquipmentHauling from "../pages/equipmenthauling/EquipmentHauling";
import SiteToSite from "../pages/siteToSitetransportation/SiteToSite";
import ProjectLogistics from "../pages/projectlogistics/ProjectLogistics";
import CustomTransportSolutions from "../pages/customtransportSolutions/CustomTransportSolutions";
import Ongoing from "../pages/ongoing/Ongoing";
import Completed from "../pages/completed/Completed";

function Routers() {
  return (
    <>
      <TopHeader />
      <Header />
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/project" element={<Project />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/equipment-rental" element={<EquipmentRental />} />
        <Route path="/manpower-supply" element={<ManpowerSupply />} />
        <Route path="/transporation-services" element={<Transportation />} />
        <Route path="/Transport-services" element={<Transport />} />
        <Route path="/blogs-Team" element={<BlogsTeam />} />
        <Route path="/services" element={<Services />} />
        <Route path="/general-contracting" element={<GeneralContracting />} />
        <Route path="/residential-projects" element={<ResidentialProject />} />
        <Route path="/infrastructure-projects" element={<Infrastructure />} />

        <Route path="/renovation-finishing" element={<RenovationFinishing />} />
        <Route path="/project-supervision" element={<ProjectSupervision />} />


        <Route path="/heavy-equipment" element={<HeavyEquipment />} />
        <Route path="/excavators" element={<Excavators/>} />
        <Route path="/bulldozers" element={<Bulldozers/>} />
        <Route path="/light-equipment" element={<LightEquipment />} />
        <Route path="/cranes-equipment" element={<Cranes />} />
        <Route path="/loader-equipment" element={<Loader />} />
        <Route path="/rental-equipment" element={<RentalTerms />} />
        <Route path="/operater-equipment" element={<Operator />} />
        <Route path="/withoperater-equipment" element={<WithoutOperator />} />
        <Route path="/packages-equipment" element={<Packages />} />
        {/* <Route path="/elctroinics-equipment" element={<Electricians />} /> */}
        <Route path="/elctroinics-equipment" element={<Electricians />} />

        <Route path="/plumber-equipment" element={<Plumbers />} />
        <Route path="/welders-equipment" element={<Welders />} />
        <Route path="/technicians-equipment" element={<Technicians />} />
        <Route path="/mechincal-equipment" element={<MechanicalTechnicians />} />
        <Route path="/civil-equipment" element={<CivilTechnicians />} />
        <Route path="/short-equipment" element={<ShortTerm />} />
        <Route path="/commercial-projects" element={<Commercial />} />
        <Route path="/long-term" element={<LongTerm />} />
        <Route path="/ongoing-projects" element={<Ongoing />} />
        <Route path="/completed" element={<Completed />} />
        <Route path="/job-details" element={<JobDetails />} />
        <Route path="/job-info" element={<JobInfo />} />
        <Route path="/view-project" element={<ViewProject />} />

        <Route path="/Project-Details" element={<ProjectDetails />} />
        <Route path="/material-transport" element={<MaterialTransport />} />
        <Route path="/heavy-equipment-hauling" element={<EquipmentHauling />} />
        <Route path="/site-to-site-transportation" element={<SiteToSite />} />
        <Route path="/project-logistics" element={<ProjectLogistics />} />
        <Route path="/custom-transport-solutions" element={<CustomTransportSolutions />} />
        <Route path="/GetAQat" element={<Quote />} />
      </Routes>
      <Footer />
    </>
  );
}

export default Routers;
